var _path, _rect, _path2, _rect2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapIconPrevix({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 50,
    viewBox: "0 0 38 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.8451 29.3438L18.9508 49.823L3.05643 29.3438H34.8451Z",
    fill: "#003E5F"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 37.9018,
    height: 34.9393,
    rx: 14.6717,
    fill: "#003E5F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3721 29.0645L18.9508 48.9342L3.52951 29.0645H34.3721Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.563965,
    y: 0.59375,
    width: 36.7738,
    height: 33.8994,
    rx: 14.235,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1628 18.0007V21.6602L19.019 25.8945L11.8459 21.7073L11.8562 18.1225L9.50272 16.6602V23.0986L19.019 28.5621L28.4131 23.1595V16.6602L26.1628 18.0007Z",
    fill: "url(#paint0_linear_396_11177)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9579 9.247L22.1371 11.0953L24.4287 9.69383L18.9579 6.52539L13.5078 9.71414L15.7786 11.0953L18.9579 9.247Z",
    fill: "url(#paint1_linear_396_11177)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49524 6.67383V11.0946L8.03697 12.0086V14.8248L15.7993 19.3744L14.3678 20.2953L18.9992 22.9491L23.5063 20.2681L22.1025 19.3476L29.8376 14.8114V12.0086L31.4065 11.0946V6.67383L19.7903 13.4709L18.9509 13.0107L18.1528 13.4709L6.49524 6.67383Z",
    fill: "url(#paint2_linear_396_11177)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_396_11177",
    x1: 18.9575,
    y1: 16.6602,
    x2: 18.9575,
    y2: 28.5621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#077DB6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_396_11177",
    x1: 18.9678,
    y1: 6.52539,
    x2: 18.9678,
    y2: 11.0953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#077DB6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_396_11177",
    x1: 18.9509,
    y1: 22.9491,
    x2: 18.9509,
    y2: 6.67383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D0F49"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIconPrevix);
export default __webpack_public_path__ + "static/media/mapIconPrevix.913d724628ddbb6b02c0fabdb4998977.svg";
export { ForwardRef as ReactComponent };